import { Outlet, Navigate } from "react-router-dom";
import { token } from "../utils/utils";

const AuthGuard = () => {

    return token ? <Outlet /> : <Navigate to="/login" />
};

export default AuthGuard;
